import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const BrandContext = createContext(null);

export const BrandProvider = ({ children }) => {
  const [brands, setBrands] = useState([]);
  const [selected, setSelectedState] = useState(localStorage.getItem("hwg-brand") || "");

  const refreshBrands = useCallback(() => {
    api.get("/brands").then((r) => {
      setBrands(r.data);
      const current = localStorage.getItem("hwg-brand") || "";
      if (current && !r.data.some((b) => b.name === current)) {
        localStorage.removeItem("hwg-brand");
        setSelectedState("");
      }
    });
  }, []);

  useEffect(() => { refreshBrands(); }, [refreshBrands]);

  const setSelected = (name) => {
    if (name) localStorage.setItem("hwg-brand", name);
    else localStorage.removeItem("hwg-brand");
    setSelectedState(name);
  };

  return <BrandContext.Provider value={{ brands, selected, setSelected, refreshBrands }}>{children}</BrandContext.Provider>;
};

export const useBrand = () => useContext(BrandContext);
